import api from '@/helpers/api';
import entities from '@/constants/modules/entities';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import jobs from '@/constants/modules/jobs';
const signalR = require("@microsoft/signalr");
export const smart = {
    state: {
        loadingData: true,
        refreshRequired: false,
        smartData: null,
        modalJob: null,
        smartStartDate: null,
        smartEndDate: null,
        showJobDialog: false,
        showJobCompleteDialog: false,
        showJobReworkDialog: false,
        showRefreshRequired: false,
        showJobPreprocessDialog: false,
        preprocessJob: null,
        preprocessSaving: false,
        preprocessType: null,
        pretreatmentTableData: [],
        pretreatmentTableDataLoading: false,
        showBulkSchedule: false,
        showTaskEstimateDialog: false,
        showScheduleTimeDialog: false,
        scheduleTimeJob: null,
        scheduleTimeEditMode: false,
        partiallyCompleted: false,
        smartKey: 0,
        smartLock: false,
        bulkUpdateJobs: [],
        smartScrollPos: 0,
        smartScrollLeft: 0,
        hideArchived: false,
        currentlyScheduled: [],
        averageLine1ColourChange: 0,
        averageLine2ColourChange: 0,
        breakTime: 0,
    },
    mutations: {
        setCurrentlyScheduled(state, scheduled) {
            state.currentlyScheduled = scheduled;
        },
        setSmartHideArchived(state, hide) {
            state.hideArchived = hide;
        },
        setSmartScrollPos(state, smartScrollPos) {
            state.smartScrollPos = smartScrollPos;
        },
        setSmartScrollLeft(state, smartScrollLeft) {
            state.smartScrollLeft = smartScrollLeft;
        },
        setBulkUpdateJobs(state, bulkJobs) {
            state.bulkUpdateJobs = bulkJobs;
        },
        setSmartLock(state, smartLock) {
            state.smartLock = smartLock;
        },
        setPartiallyComplete(state, partiallyCompleted) {
            state.partiallyCompleted = partiallyCompleted;
        },
        setShowBulkSchedule(state, showBulkSchedule) {
            state.showBulkSchedule = showBulkSchedule;
        },
        setShowTaskEstimateDialog(state, show) {
            state.showTaskEstimateDialog = show;
        },
        setShowScheduleTimeDialog(state, show) {
            state.showScheduleTimeDialog = show;
        },
        setScheduleTimeJob(state, job) {
            state.scheduleTimeJob = job;
        },
        setScheduleTimeEditMode(state, editMode) {
            state.scheduleTimeEditMode = editMode;
        },
        setPretreatmentTableDataLoading(state, loading) {
            state.pretreatmentTableDataLoading = loading;
        },
        setPretreatmentTableData(state, data) {
            state.pretreatmentTableData = data;
        },
        setPreprocessJob(state, preprocessJob) {
            state.preprocessJob = preprocessJob;
        },
        setShowJobPreprocessDialog(state, show) {
            state.showJobPreprocessDialog = show;
        },
        setRefreshRequired(state, refreshRequired) {
            state.refreshRequired = refreshRequired;
        },
        setLoadingData(state, loading) {
            state.loadingData = loading;
        },
        setSmartData(state, smartData) {
            state.smartData = smartData;
            state.smartKey++;
        },
        setDialogJob(state, dialogJob) {
            state.dialogJob = dialogJob;
        },
        setShowJobDialog(state, showJobDialog) {
            state.showJobDialog = showJobDialog;
        },
        setShowJobCompleteDialog(state, showJobCompleteDialog) {
            state.showJobCompleteDialog = showJobCompleteDialog;
        },
        setShowJobReworkDialog(state, showJobReworkDialog) {
            state.showJobReworkDialog = showJobReworkDialog;
        },
        setSmartStartDate(state, startDate) {
            state.smartStartDate = startDate;
        },
        setSmartEndDate(state, endDate) {
            state.smartEndDate = endDate;
        },
        setPreprocessSaving(state, saving) {
            state.preprocessSaving = saving;
        },
        setPreprocessType(state, type) {
            state.preprocessType = type;
        },
        updateDialogJob(state, job) {
            if (state.smartData && state.dialogJob) {
                state.dialogJob = job;
                // Update job in columns
                state.smartData.forEach(column => {
                    let index = column.jobs.findIndex(item => item.jobTaskId == job.jobTaskId);
                    if (index > -1) {
                        column.jobs[index] = job;
                    }
                });
            }
            state.smartKey++;
        },
        setSmartTimings(state, { averageLine1ColourChange, averageLine2ColourChange, breakTime }) {
            state.averageLine1ColourChange = averageLine1ColourChange;
            state.averageLine2ColourChange = averageLine2ColourChange;
            state.breakTime = breakTime;
        },
        updateSmartColumn(state, column) {
            let index = state.smartData.findIndex(item => item.name == column.name);
            if (index > -1) {
                state.smartData[index] = column;
            }
            state.smartKey++;
        }
    },
    actions: {
        initSmart({ commit, dispatch, state, rootState }) {
            var cookieStart = Cookies.get('smart-start-date');
            var cookieEnd = Cookies.get('smart-end-date');
            if (cookieStart && cookieEnd) {
                commit('setSmartStartDate', cookieStart);
                commit('setSmartEndDate', cookieEnd);
            } else {
                let today = dayjs();
                commit('setSmartStartDate', (today.day() === 1
                    ? dayjs().subtract(3, 'day')
                    : dayjs().subtract(1, 'day')).format('YYYY-MM-DD'));
                const nextSunday = today.day(7);
                commit('setSmartEndDate', nextSunday.add(7, 'day').format('YYYY-MM-DD'));
            }
            // Load auto refresh prompt
            if (rootState.auth.user) {
                const options = {
                    accessTokenFactory: () => {
                        return `${rootState.auth.user.token}`;
                    },
                };
                let connection = new signalR.HubConnectionBuilder()
                    .withUrl(process.env.VUE_APP_API_URL + "hubs/smart", options)
                    .build();
                connection.start().catch(error => { });
                connection.on("RefreshRequired", data => {
                    commit('setRefreshRequired', rootState.auth.user.email != data);
                });
                connection.on('finished', (update) => {
                    connection.stop();
                });
            }
            let smartLock = Cookies.get('smart-lock');
            if (typeof smartLock !== 'undefined') {
                commit('setSmartLock', smartLock == 'true');
            }
            dispatch('refreshSmartData');
        },
        toggleSmartLock({ commit, state }, lock) {
            commit('setSmartLock', lock);
            Cookies.set('smart-lock', lock);
        },
        refreshSmartData({ commit, dispatch, state }) {
            commit('setLoadingData', true);
            api.get('/dashboard/smartjobs?startDate=' + state.smartStartDate + "&endDate=" + state.smartEndDate + "&hideArchived=" + state.hideArchived)
                .then(res => {
                    commit('setLoadingData', false);
                    commit('setRefreshRequired', false);
                    commit('setSmartTimings', {
                        averageLine1ColourChange: res.data.averageLine1ColourChange,
                        averageLine2ColourChange: res.data.averageLine2ColourChange,
                        breakTime: res.data.breakTime,
                    });
                    dispatch('loadSmartData', res.data.lists);
                    dispatch('loadSmartColumns');
                }).catch(error => {
                    commit('setLoadingData', false);
                    dispatch('showErrorSnack', "We ran into an issue...");
                });
        },
        loadSmartColumns({ commit, state }) {
            state.smartData.forEach(column => {
                let cookieName = 'smart-column-expand-' + column.status;
                if (column.statusDate) {
                    cookieName += '-' + column.statusDate.substring(0, 10);
                }
                let cookieExpand = Cookies.get(cookieName);
                if (typeof cookieExpand !== 'undefined') {
                    column.expand = cookieExpand == 'true';
                    commit('updateSmartColumn', column);
                }
            });
        },
        expandSmartColumn({ commit, state }, column) {
            column.expand = !column.expand;
            commit('updateSmartColumn', column);
            let cookieName = 'smart-column-expand-' + column.status;
            if (column.statusDate) {
                cookieName += '-' + column.statusDate.substring(0, 10);
            }
            Cookies.set(cookieName, column.expand, { expires: 7 });
        },
        saveSmartDates({ dispatch, state }) {
            if (state.smartStartDate) {
                Cookies.set('smart-start-date', state.smartStartDate, { expires: 0.4 });
            }
            if (state.smartEndDate) {
                Cookies.set('smart-end-date', state.smartEndDate, { expires: 0.4 });
            }
            dispatch('refreshSmartData');
        },
        loadSmartData({ commit, dispatch }, data) {
            commit('setShowJobDialog', false);
            commit('setShowJobCompleteDialog', false);
            commit('setShowJobReworkDialog', false);
            commit('setSmartData', data);
            dispatch('loadSmartColumns');
        },
        openSmartJobDialog({ commit, dispatch }, job) {
            commit('setDialogJob', job);
            dispatch('initNotes', { classId: job.id, className: 'Job'});
            commit('setShowJobDialog', true);
        },
        openSmartJobCompleteDialog({ commit }) {
            commit('setShowJobCompleteDialog', true);
            commit('setPartiallyComplete', false);
        },
        openSmartJobCompletePartialDialog({ commit }) {
            commit('setShowJobCompleteDialog', true);
            commit('setPartiallyComplete', true);
        },
        openJobReworkDialog({ commit }, job) {
            // Build dialog job
            commit('setDialogJob', {
                taskDate: dayjs().format('YYYY-MM-DD'),
                name: job.name,
                jobId: job.id,
                contact: job.contact,
                taskSubTotal: job.activeTask.estimatedSubtotalCompleted ? job.activeTask.estimatedSubtotalCompleted : job.outstandingSubtotal,
                jobItems: job.jobItems
            });
            commit('setShowJobReworkDialog', true);
        },
        openSmartJobReworkDialog({ commit }) {
            commit('setShowJobReworkDialog', true);
        },
        openSmartTaskEstimateDialog({ commit }, job) {
            commit('setDialogJob', job);
            commit('setShowTaskEstimateDialog', true);
        },
        openSmartScheduleTimeCreateDialog({ commit }) {
            commit('setScheduleTimeJob', {
                scheduledDate: dayjs().format('YYYY-MM-DD'),
                estimatedHours: null,
                reason: null,
                line: jobs.JOBSTAT_LINE1
            });
            commit('setScheduleTimeEditMode', false);
            commit('setShowScheduleTimeDialog', true);
        },
        openSmartScheduleTimeEditDialog({ commit, dispatch }, job) {
            let hours = (job.l1Time || job.l2Time || 0) / 60;
            commit('setScheduleTimeJob', {
                jobId: job.jobId,
                jobTaskId: job.jobTaskId,
                reason: job.customerNumber,
                estimatedHours: hours,
                line: job.status,
                scheduledDate: job.taskDate ? dayjs(job.taskDate).format('YYYY-MM-DD') : null,
            });
            dispatch('initNotes', { classId: job.jobId, className: 'Job' });
            commit('setScheduleTimeEditMode', true);
            commit('setShowScheduleTimeDialog', true);
        },
        saveScheduleTime({ commit, dispatch, state }) {
            let job = state.scheduleTimeJob;
            let formData = new FormData();
            formData.append('reason', job.reason);
            formData.append('line', job.line);
            formData.append('estimatedHours', job.estimatedHours);
            formData.append('scheduledDate', job.scheduledDate);
            return api.post(entities.Job.ROUTE + 'scheduletime', formData)
                .then(res => {
                    commit('setShowScheduleTimeDialog', false);
                    dispatch('refreshSmartData');
                    dispatch('showSuccessSnack', 'Time scheduled!');
                }).catch(error => {
                    dispatch('showErrorSnack', 'There was an issue scheduling this time');
                });
        },
        updateScheduleTimeReason({ dispatch, state }) {
            let job = state.scheduleTimeJob;
            api.patch(entities.Job.ROUTE + job.jobId, [
                { op: "replace", path: "/customerNumber", value: job.reason },
                { op: "replace", path: "/name", value: job.reason }
            ]).then(res => {
                dispatch('refreshSmartData');
                dispatch('showSuccessSnack', 'Scheduled time updated!');
            }).catch(error => {
                dispatch('showErrorSnack', "We ran into an issue...");
            });
        },
        updateScheduleTimeHours({ dispatch, state }) {
            let job = state.scheduleTimeJob;
            let minutes = (parseFloat(job.estimatedHours) || 0) * 60;
            api.patch(entities.Job.ROUTE + job.jobId, [
                { op: "replace", path: "/lineOneEstimatedCoatingTime", value: minutes },
                { op: "replace", path: "/lineTwoEstimatedCoatingTime", value: minutes }
            ]).then(res => {
                dispatch('refreshSmartData');
                dispatch('showSuccessSnack', 'Scheduled time updated!');
            }).catch(error => {
                dispatch('showErrorSnack', "We ran into an issue...");
            });
        },
        updateScheduleTimeLine({ dispatch, state }) {
            let job = state.scheduleTimeJob;
            let formData = new FormData();
            formData.append('id', job.jobId);
            formData.append('status', job.line);
            formData.append('taskId', job.jobTaskId);
            formData.append('order', 0);
            if (job.scheduledDate) {
                formData.append('date', job.scheduledDate);
            }
            if (state.smartStartDate) {
                formData.append('startDate', state.smartStartDate);
            }
            if (state.smartEndDate) {
                formData.append('endDate', state.smartEndDate);
            }
            api.post(entities.Job.ROUTE + 'updatestatus', formData)
                .then(res => {
                    dispatch('loadSmartData', res.data.lists);
                    dispatch('showSuccessSnack', 'Scheduled time updated!');
                }).catch(error => {
                    dispatch('showErrorSnack', "We ran into an issue...");
                });
        },
        updateSmartJobTask({ commit, dispatch, state }, { path, value }) {
            let updateJob = state.dialogJob;
            api.patch('jobs/task/' + updateJob.jobTaskId, [{
                op: "replace",
                path: "/" + path,
                value: value
            }]).then(res => {
                updateJob[path] = value;
                if (path == 'estimatedPercentageRequired'){
                  updateJob.estimatedCoatingTime = updateJob.originalEstimatedCoatingTime * value;
                }
                commit('updateDialogJob', updateJob);
                dispatch('showSuccessSnack', 'Job updated!');
            }).catch(error => {
                dispatch('showErrorSnack', "We ran into an issue...");
            });
        },
        updateSmartJob({ commit, dispatch, state }, { path, value }) {
            let updateJob = state.dialogJob;
            api.patch(entities.Job.ROUTE + updateJob.jobId, [{
                op: "replace",
                path: "/" + path,
                value: value
            }]).then(res => {
                updateJob[path] = value;
                commit('updateDialogJob', updateJob);
                dispatch('showSuccessSnack', 'Job updated!');
                return;
            }).catch(error => {
                dispatch('showErrorSnack', "We ran into an issue...");
            });
        },
        updateSmartJobStatus({ dispatch, state }, { job, status, taskId, order, date }) {
            let formData = new FormData();
            formData.append('id', job.id);
            formData.append('status', status);
            if (taskId) {
                formData.append('taskId', taskId);
                formData.append('order', order);
                if (date !== null) {
                    formData.append('date', date);
                }
            }
            if (state.smartStartDate)
            {
                formData.append('startDate', state.smartStartDate);
            }
            if (state.smartStartDate) {
                formData.append('endDate', state.smartEndDate);
            }
            api.post(entities.Job.ROUTE + 'updatestatus', formData)
                .then(res => {
                    dispatch('loadSmartData', res.data.lists);
                })
                .catch(error => {
                    dispatch('showErrorSnack', "We ran into an issue...");
                });
        },
        openSmartPreprocess({ commit }, { job, type }) {
            commit('setShowJobPreprocessDialog', true);
            commit('setPreprocessType', type);
            commit('setPreprocessJob', job);
        },
        deleteSmartTime({ commit, dispatch, state }, { job, time }) {
            api.post(entities.Job.ROUTE + 'deletetime?id=' + time.id)
                .then(res => {
                    var index = job.activeTask.jobTaskTimes.indexOf(time);
                    if (index > -1) {
                        job.activeTask.jobTaskTimes.splice(index, 1);
                    }
                    commit('updateDialogJob', job);
                    dispatch('showSuccessSnack', 'Job updated!');
                })
                .catch(error => {
                    this.showErrorSnack('There was an issue completing the job');
                });
        },
        saveSmartPreprocessed({ commit, dispatch, state }, { job, date, location, supervisor, type }) {
            let formData = new FormData();
            formData.append('id', job.id);
            formData.append('date', date);
            formData.append('location', location);
            formData.append('supervisor', supervisor);
            formData.append('type', type);
            commit('setPreprocessSaving', true);
            api.post(entities.Job.ROUTE + 'markpreprocessed', formData)
                .then(res => {
                    commit('setPreprocessSaving', false);
                    commit('setShowJobPreprocessDialog', false);
                    commit('setPreprocessJob', null);
                    if (state.pretreatmentTableData) {
                        dispatch('loadPretreatmentTableData');
                    }
                    if (state.dialogJob && state.dialogJob.id == job.id) {
                        if (type == jobs.PREPRO_PRETREAT) {
                            job.datePretreatment = date == '' ? null : date;
                        } else if (type == jobs.PREPRO_BLASTING) {
                            job.dateBlasted = date == '' ? null : date;
                        } else if (type == jobs.PREPRO_STRIPPING) {
                            job.dateStripped = date == '' ? null : date;
                        }
                        commit('updateDialogJob', job);
                    }
                    dispatch('showSuccessSnack', 'Job updated!');
                })
                .catch(error => {
                    commit('setPreprocessSaving', false);
                    dispatch('showErrorSnack', "We ran into an issue...");
                });
        },
        updateSmartReceived({ dispatch, state }) {
            dispatch('updateSmartJob', { path: 'dateReceived', value: (!state.dialogJob.dateReceived ? dayjs().format('YYYY-MM-DD') : null) });
        },
        loadPretreatmentTableData({ commit, dispatch }) {
            commit('setPretreatmentTableDataLoading', true);
            api.get('dashboard/pretreatment')
                .then(res => {
                    commit('setPretreatmentTableDataLoading', false);
                    commit('setPretreatmentTableData', res.data);
                }).catch(error => {
                    commit('setPretreatmentTableDataLoading', true);
                    dispatch('showErrorSnack', 'There was an issue getting the jobs');
                });
        },
        showBulkSchedule({ commit, dispatch, getters }) {
            commit('setBulkUpdateJobs', getters.smartScheduleJobs);
            commit('setShowBulkSchedule', true);
        }
    },
    getters: {
        smartScheduleJobs(state) {
            if (state && state.smartData && state.smartData.length > 0) {
                return state.smartData.find(column => column.status == jobs.JOBSTAT_SCHEDULE).jobs.sort((a, b) => {
                    if (!a.name || !b.name) {
                        return 100;
                    }
                    let numA = parseInt(a.name.split('-')[1], 10);
                    let numB = parseInt(b.name.split('-')[1], 10);
                    return numA - numB;
                });
            }
            return [];
        }
    }
}